import { combineReducers } from 'redux';

import { profileReducer } from 'app/dux/profile/reducer';
import { versionsReducer } from 'app/components/routes/versions/reducer';
import { privacyReducer } from 'app/components/routes/privacy/reducer';

export default combineReducers( {
    profile: profileReducer,
    versions: versionsReducer,
    privacy: privacyReducer
} );
